import React, { useState } from 'react';

import { DatePicker } from 'antd';

function CustomRangePicker({
  defaultValue = [],
  onChange,
  dateFormat,
  disabledDate = false,
  minDate,
  maxDate,
  className = 'date-picker',
  separator = '-',
  locale,
  onOpenChanged = () => {},
}) {
  const [dates, setDates] = useState(null);

  const onOpenChange = (open) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
    onOpenChanged(open);
  };

  return (
    <DatePicker.RangePicker
      locale={locale}
      value={dates || defaultValue}
      className={className}
      format={dateFormat}
      showTime={{ format: 'HH:mm' }}
      separator={separator}
      onChange={onChange}
      onCalendarChange={(value) => setDates(value)}
      onOpenChange={onOpenChange}
      minDate={disabledDate ? minDate : null}
      maxDate={disabledDate ? maxDate : null}
      disabledDate={(current) => {
        // the end date cannot be the same as the start date
        if (disabledDate) {
          current.set({
            second: 0,
            millisecond: 0,
          });
          const tooEarly = minDate && current < minDate;
          const tooLate = maxDate && current > maxDate;
          return !!tooEarly || !!tooLate;
        }
      }}
    />
  );
}

export default CustomRangePicker;
